<template>
<div class="container-fluid">
  <div class="row mobile flex-nowrap">
    <SideBar id="desktop" />
    <MobileSideBar id="mobile" />
    <QuickUserLookup id="quick-user-lookup" />
  </div>
</div>
</template>

<script>
// @ is an alias to /src
import SideBar from '@/components/SideBar.vue'
import QuickUserLookup from '@/components/QuickUserLookup.vue'
import MobileSideBar from '@/components/MobileSideBar.vue';

export default {
  name: 'Home',
  components: {
    SideBar,
    QuickUserLookup,
    MobileSideBar
  },
  
}
</script>

<style scoped>
#mobile{
    display: none
  }
#desktop{
  max-width: 100%
}
@media screen and (max-width: 768px){
  #mobile{
    display: flex;
  }
  #desktop{
    display: none
  }
  .mobile{
    display: grid
  }
}
</style>
